import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import Notification from "../../elements/notification/Notification";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { TextField } from "@material-ui/core";
import RatesEditForm from "./RatesEditForm";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { StyledFeeDetailsWrapper } from "../../fee/styledFee";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const RatesDetailsContainer = ({ match }) => {
  const { t } = useTranslation("ratesPage");
  const [rate, setRate] = useState();
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/rate-bases/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setRate(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, []);

  if (!rate) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (rate.length === 0) {
    return <Alert severity="warning">{t("rates.details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("rates.details.meta.title")} {rate.currency.asset}/{rate.service.name} • eXsoft.io</title>
        </Helmet>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("rates.details.changeForm.rate")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("rates.details.changeForm.currency")}
                  type="text"
                  value={rate.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("rates.details.changeForm.service")}
                  type="text"
                  value={getServiceNameWithNickname(rate.service.name, rate.service.nickname)}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("rates.details.changeForm.rateSelling")}
                  type="text"
                  value={rate.rateSelling}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("rates.details.changeForm.ratePurchase")}
                  type="text"
                  value={rate.ratePurchase}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("rates.details.changeForm.selling")}
                  type="text"
                  value={rate.selling}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
                <TextField
                  className="grid-form__input"
                  label={t("rates.details.changeForm.purchase")}
                  type="text"
                  value={rate.purchase}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("rates.details.changeForm.adjustment")}
              </StyledBlockLabel>
              <RatesEditForm
                rate={rate}
                setRate={setRate}
                notification={notification}
                setNotification={setNotification}
                url="/api/rate-bases/"
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default RatesDetailsContainer;